module.exports = __webpack_public_path__ + "img/melia-resort-2.f65f7204.jpg";